import { type FC } from 'react';
import Modal from '@components/modal';

export const SettingsModal: FC<{ isOpen: boolean; onClose: () => void }> = ({
  isOpen,
  onClose,
}) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Kawaii Settings ⊂((・▽・))⊃" size="md">
      <div className="p-6 space-y-6">
        <div className="space-y-4">
          <h3 className="text-lg font-medium text-pink-700 dark:text-pink-200">
            Personalization (◕‿◕✿)
          </h3>

          <div className="space-y-2">
            <label
              htmlFor="theme"
              className="block text-sm font-medium text-pink-600 dark:text-pink-300"
            >
              Chat Background Theme
            </label>
            <select
              id="theme"
              className="w-full rounded-lg border-2 border-pink-200 dark:border-pink-700 p-2 bg-pink-50 dark:bg-gray-800"
            >
              <option value="sakura">Sakura Petals ✿</option>
              <option value="stars">Starry Night ⭐</option>
              <option value="hearts">Floating Hearts 💕</option>
            </select>
          </div>

          <div className="space-y-2">
            <label
              htmlFor="style"
              className="block text-sm font-medium text-pink-600 dark:text-pink-300"
            >
              Message Style
            </label>
            <select
              id="style"
              className="w-full rounded-lg border-2 border-pink-200 dark:border-pink-700 p-2 bg-pink-50 dark:bg-gray-800"
            >
              <option value="bubble">Bubble Style (｡♥‿♥｡)</option>
              <option value="flat">Flat Style ⊂((・▽・))⊃</option>
              <option value="pixel">Pixel Style (◕‿◕✿)</option>
            </select>
          </div>
        </div>
      </div>
    </Modal>
  );
};
